import styles from './styles.module.scss';

import { t } from 'i18next';
import { useRef, useState } from 'react';

import useOnClickOutside from 'models/utils/useOnClickOutside';
import Notification from 'models/Notifications/Notification';
import Toggle from '../toggle';
import Empty from '../empty';
import Card from '../card';
import Skeleton from '../skeleton';
import useFetchNotifications from 'hooks/useFetchNotifications';
import { checkAllAsRead } from 'services/notifications';
import { useNotifications } from 'context/NotificationContext';

type Container = {
  onClick?: () => void,
}

function Container(props : Container) : JSX.Element {
  const [showOnlyUnread, setShowOnlyUnread] = useState<boolean>(true);

  const { notifications, setAllAsRead } = useNotifications();
  const { isLoading } = useFetchNotifications();

  const dropdownRef = useRef<HTMLDivElement>(null);


  if(props.onClick)
    useOnClickOutside(dropdownRef, props.onClick, ['biobar-subheader-action', 'biobar-notification-more-dropdown-div', 'biobar-notification-more-dropdown-link']);

  const getNotifications = () : Array<Notification> => {
    if(!showOnlyUnread)
      return notifications;

    return notifications.filter(x => !x.read);
  };

  function List() : JSX.Element {
    const notifications = getNotifications();

    const onClick = () : void => {
      checkAllAsRead()
        .then(() => {
          setAllAsRead();
          window.dispatchEvent(new Event('biobar-notifications-read'));
        });
    };

    if(notifications.length === 0)
      return <div className={styles['biobar-notifications-empty']}>
        <Empty
          iconName='notifications'
          title={t('biobar.notification.empty.title')}
          message={t('biobar.notification.empty.body')}
        />
      </div>;

    return(
      <>
        <div className={styles['biobar-notifications-subheader']}>
          <p>{t('biobar.notification.subheader')}</p>
          <a id="biobar-subheader-action" onClick={onClick}>{t('biobar.notification.subheader.action')}</a>
        </div>
        <div className={styles['biobar-notifications-content']}>
          {notifications.map((notification, i) => <Card {...notification} key={i}/>)}
          <div className={styles['biobar-notifications-end-content']}>
            <Empty
              iconName='flag'
              title={t('biobar.notification.content.end.title')}
              message={t('biobar.notification.empty.body')}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      ref={dropdownRef}
      id={styles['biobar-notifications']}>
      <div className={styles['biobar-notifications-header']}>
        <h4>{t('biobar.notification.header')}</h4>
        <Toggle
          checked={showOnlyUnread} 
          onClick={() : void =>  setShowOnlyUnread((x) => !x)} />
      </div>
      {isLoading ? <Skeleton /> : <List />}
    </div>
  );
}

export default Container;